import * as React from "react";
import { registerLWPComponent } from "VSS/LWP";
import { IPrimaryArtifactProps, PrimaryArtifact } from "Presentation/Scripts/TFS/Controls/LinkedArtifacts/Components/ArtifactRenderer";

// Used from the new wiki experience for rendering Primary Artifact component
export class PrimaryArtifactComponentNwpWrapper extends React.Component<IPrimaryArtifactProps> {
    public render(): JSX.Element {
        return <PrimaryArtifact.Component  {...this.props} /> ;
    }
}

registerLWPComponent("Wiki.PrimaryArtifactRenderer.Component", PrimaryArtifactComponentNwpWrapper);
